import { css } from '@emotion/react';
import _ from 'lodash';
import { ThemeColors } from '../theme/foundations/colors';
import { colorIsDark } from './colors';

export const backgroundStyles = (props: { background: string }) => {
  const color = _.get(ThemeColors, props.background);

  if (!color) {
    return css``;
  }

  return css`
    background-color: ${color};
  `;
};

export const colorStyle = (color: string, contrastColor?: string) => {
  if (contrastColor) {
    const backgroundColor = _.get(ThemeColors, contrastColor);
    const isDark = colorIsDark(backgroundColor);

    if (isDark) {
      return css`
        color: ${ThemeColors.white[500]};
      `;
    } else {
      return css`
        color: ${ThemeColors.black[500]};
      `;
    }
  }

  const colorValue = _.get(ThemeColors, color);

  return css`
    color: ${colorValue};
  `;
};
